import { useQuery } from '@tanstack/react-query'

import { dealQueryKeys, dealApi, type TDeal } from '@crm/entities/deal'

export const useGetDealDetailsQuery = (id: TDeal['id']) =>
  useQuery({
    queryKey: dealQueryKeys.detail(id),
    queryFn: () => dealApi.getDealDetails(id),
    enabled: Boolean(id),
  })
